import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';   // 👈 thêm dòng này
import './index.css';
import './assets/css/auth.css';
import "./assets/css/chunk-vendors.9b5389fb.css";
import "./assets/css/app.bd61281a.css";
import "./assets/fonts/fontawesome/all.min.css";

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
